// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__18A7b","notes":"Notes_notes__1XX_3","note":"Notes_note__k1Ehq","markdown":"Notes_markdown__2k1TO"};